// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
    margin: 12px;
}

/* One centered column under the header, like the Busy Bees page. Paired
   with .container so it beats the global .container max-width. */
.container.intake-layout {
  max-width: 640px;
  margin: 0 auto 24px;
}

.intake-form {
  background-color: var(--surface-raised);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-soft);
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.intake-form label,
.intake-form fieldset {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: none;
  margin: 0;
  padding: 0;
  font-weight: 600;
  color: var(--text-primary);
}

/* Checkbox beside its label (the generic \`.intake-form label\` rule above
   stacks them). */
.intake-form .check-option {
  flex-direction: row;
  padding: 12px;
}

.intake-form input[type="text"] {
  border: 1px solid var(--border-default);
  border-radius: 10px;
  padding: 12px 14px;
  font: inherit;
  background-color: var(--surface-raised);
}

.intake-form input[type="text"]:focus {
  outline: 2px solid var(--focus-ring);
  border-color: var(--text-accent);
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
  margin-top: 4px;
}

/* The whole chip is a <label>, so clicking anywhere in it toggles the box. */
.check-option {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: var(--surface-sunken);
  border-radius: 10px;
  padding: 12px 12px;
  font-weight: 500;
  color: var(--text-primary);
  cursor: pointer;
}

.check-option input {
  width: 18px;
  height: 18px;
  accent-color: var(--text-accent);
  cursor: pointer;
}

.form-success {
  margin: 0;
  color: var(--text-primary);
  font-weight: 600;
}

.form-error {
  margin: 0;
  color: var(--text-accent);
  font-weight: 600;
}

/* Underlined so the fallback address reads as a link — links elsewhere are
   distinguished by color, which does nothing inside already-accent-colored
   error text. */
.form-error a,
.form-error a:visited {
  color: inherit;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Intake.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;iEACiE;AACjE;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;kBACkB;AAClB;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,eAAe;AACjB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;gBAEgB;AAChB;;EAEE,cAAc;EACd,0BAA0B;AAC5B","sourcesContent":[".btn {\n    margin: 12px;\n}\n\n/* One centered column under the header, like the Busy Bees page. Paired\n   with .container so it beats the global .container max-width. */\n.container.intake-layout {\n  max-width: 640px;\n  margin: 0 auto 24px;\n}\n\n.intake-form {\n  background-color: var(--surface-raised);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-soft);\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.intake-form label,\n.intake-form fieldset {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: none;\n  margin: 0;\n  padding: 0;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* Checkbox beside its label (the generic `.intake-form label` rule above\n   stacks them). */\n.intake-form .check-option {\n  flex-direction: row;\n  padding: 12px;\n}\n\n.intake-form input[type=\"text\"] {\n  border: 1px solid var(--border-default);\n  border-radius: 10px;\n  padding: 12px 14px;\n  font: inherit;\n  background-color: var(--surface-raised);\n}\n\n.intake-form input[type=\"text\"]:focus {\n  outline: 2px solid var(--focus-ring);\n  border-color: var(--text-accent);\n}\n\n.checkbox-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 12px;\n  margin-top: 4px;\n}\n\n/* The whole chip is a <label>, so clicking anywhere in it toggles the box. */\n.check-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: var(--surface-sunken);\n  border-radius: 10px;\n  padding: 12px 12px;\n  font-weight: 500;\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n.check-option input {\n  width: 18px;\n  height: 18px;\n  accent-color: var(--text-accent);\n  cursor: pointer;\n}\n\n.form-success {\n  margin: 0;\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n.form-error {\n  margin: 0;\n  color: var(--text-accent);\n  font-weight: 600;\n}\n\n/* Underlined so the fallback address reads as a link — links elsewhere are\n   distinguished by color, which does nothing inside already-accent-colored\n   error text. */\n.form-error a,\n.form-error a:visited {\n  color: inherit;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
